import { render, staticRenderFns } from "./BloodSugarList.vue?vue&type=template&id=723ae2e7&scoped=true&"
import script from "./BloodSugarList.vue?vue&type=script&lang=js&"
export * from "./BloodSugarList.vue?vue&type=script&lang=js&"
import style0 from "./BloodSugarList.vue?vue&type=style&index=0&id=723ae2e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723ae2e7",
  null
  
)

export default component.exports